import {
  IGroupDto,
  IRoleDto,
  IUserRoleDto,
  IUserWithRightsDtoV2,
  UserRoleUpdateDto
} from '../../../../../api/models/Einstellungen/userRoleDto';

// --- Legacy (non-SSO) utils ---

export const isUserAdministrator = (row: IUserRoleDto | UserRoleUpdateDto) => {
  return row.groups.some((group: IGroupDto) => group.name === 'Administration');
};

export const isUserRegistered: (row: IUserRoleDto) => boolean = function (
  row: IUserRoleDto
): boolean {
  return (row.firstName && row.lastName) !== null;
};

export function removeRoleSachbearbeitung(
  groupItem: IGroupDto
): Array<IRoleDto> {
  return groupItem.roles.filter(
    (role: IRoleDto): boolean => role.name !== 'Sachbearbeitung'
  );
}

export const isLastAdministrator = (
  usersGroupsAndRoles: Array<IUserRoleDto>
): boolean => {
  const administrators: Array<IGroupDto> = usersGroupsAndRoles
    .flatMap((user: IUserRoleDto): Array<IGroupDto> => user.groups)
    .filter((group: IGroupDto): boolean => group.name === 'Administration');
  return administrators.length <= 1;
};

// --- SSO utils ---

export const isUserAdministratorSSO = (row: IUserWithRightsDtoV2) => {
  return row.systemRoles.includes('Administration');
};

export const isUserRegisteredSSO: (row: IUserWithRightsDtoV2) => boolean =
  function (row: IUserWithRightsDtoV2): boolean {
    return (row.firstName && row.lastName) !== null;
  };
